// @flow

import React from 'react';

type Props = {
  siteName: string
};

const HorseSwapRules: React.FC<Props> = ({ siteName }: Props) => (
  <div>
    <h2>HOW DOES THE RACING SWAP WORK?</h2>
    <p>
      Horses and greyhounds can be swapped up until the scheduled start time of their race. After
      the scheduled start time has passed horses/greyhounds will be locked and are ineligible to be
      swapped. Horses/greyhounds can only be swapped for another in the same race.
    </p>
    <p>
      Please note {siteName} reserves the right to extend the scheduled start time of any race. As
      an example, the first race in a slate may have its scheduled start time extended.
    </p>
    <h2>HOW MANY TIMES CAN I SWAP A SELECTION BEFORE THE SCHEDULED START TIME OF THEIR RACE?</h2>
    <p>
      There is no limit on the amount of swaps before the scheduled start time of the
      horses/greyhounds race.
    </p>
    <h2>WHERE ON THE SITE CAN I USE THE SWAP FEATURE?</h2>
    <p>The Swap tab is located in the My Teams Section.</p>
    <h2>Can a swap be reversed?</h2>
    <p>
      Yes, you have the ability to swap in a horse/greyhound that has previously been swapped out.
    </p>
    <h2>CAN I SWAP MULTIPLE LINEUPS WITH A COMBINATION OF DIFFERENT SELECTIONS?</h2>
    <p>
      No. This solution is solely designed to swap individual selections, not to restructure a
      lineup.
    </p>
    <h2>WHAT HAPPENS WHEN SWAPPING A SELECTION I HAVE IN DIFFERENT SLATES?</h2>
    <p>
      Horses/greyhounds can only be swapped for one slate at a time. If you want to swap a horse you
      have in multiple slates you will need to make an individual swap for each slate.
    </p>
    <h2>CAN I USE SWAP ON BOTH DESKTOP AND ON THE APP?</h2>
    <p>Yes.</p>
    <h2>
      CAN I SEE THE PERCENTAGE THAT A HORSE/GREYHOUND HAS BEEN SELECTED PRIOR TO THE SCHEDULED START
      TIME OF THEIR RACE?
    </h2>
    <p>
      No. Percentages will only be displayed for a horse/greyhound when they are locked and can no
      longer be swapped.
    </p>
    <h2>CAN I SEE SELECTIONS NOT LOCKED IN OPPONENT TEAMS?</h2>
    <p>No. When comparing teams only horses/greyhounds that are locked will be displayed.</p>
    <h2>What does exposure % mean?</h2>
    <p>
      This is the percentage of your entries that have an individual horse/greyhound. This only
      shows the exposure for the slate selected.
    </p>
    <h2>WHY DIDN’T MY SWAP WORK?</h2>
    <p>
      In the majority of cases the swap could not be processed prior to the horses/greyhounds
      scheduled race time.
    </p>
    <h2>WHY IS MY HORSE/GREYHOUND NOT SHOWN AS AN OPTION TO SWAP OUT?</h2>
    <p>
      When the scheduled start time of a horses/greyhounds race has been reached they will no longer
      be an option to swap.
    </p>
    <h2>WILL {siteName} NOTIFY ME IF MY SELECTION IS SCRATCHED?</h2>
    <p>
      It is always the responsibility of an entrant to monitor their lineups and selections status.
      However, {siteName} will automatically check 10-15 mins before the scheduled start time of
      each race in a slate for scratched labels. If you have made selections with a scratched label
      a push notification will be sent to you. Note that your mobile phone must be configured to
      accept {siteName} notifications.
    </p>
    <h2>Can I rely on the labels?</h2>
    <p>
      Labels are supplied via third-party statistics feeds. While they&apos;re accurate most of the
      time, we can&apos;t guarantee 100% accuracy.
    </p>
    <h2>
      WHAT HAPPENS WHEN MY SELECTION IS SCRATCHED AFTER THE SCHEDULED START TIME OF THEIR RACE?
    </h2>
    <p>Unfortunately, you will be unable to make the swap.</p>
    <h2>CAN I USE THE SWAP IN ALL CONTESTS?</h2>
    <p>Yes, the swap feature applies to all racing contests.</p>
  </div>
);

export default HorseSwapRules;
